import { useState } from 'react';
import { Alert, Button, Popconfirm } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';
import useDemoFarm from '../hooks/useDemoFarm';

/**
 * Shown on every page while the account has the sample "Demo Farm", with a one-click remove.
 * Closing it hides it until the next page load.
 */
const DemoFarmBanner = ({ enabled }) => {
  const { demoFarm, removeDemo } = useDemoFarm({ enabled });
  const [hidden, setHidden] = useState(false);

  if (!enabled || !demoFarm || hidden || removeDemo.isSuccess) {
    return null;
  }

  return (
    <Alert
      banner
      type="info"
      icon={<ExperimentOutlined />}
      showIcon
      closable
      onClose={() => setHidden(true)}
      message={`Your account includes "${demoFarm.name}" with sample records to explore. Your own farms are separate.`}
      action={
        <Popconfirm
          title="Remove the demo farm?"
          description="Its animals and all sample records are deleted. Your own farms are not changed."
          okText="Remove"
          okButtonProps={{ danger: true }}
          onConfirm={() => removeDemo.mutateAsync()}
          disabled={removeDemo.isPending}
        >
          <Button size="small" danger loading={removeDemo.isPending} disabled={removeDemo.isPending}>
            Remove demo farm
          </Button>
        </Popconfirm>
      }
    />
  );
};

export default DemoFarmBanner;
